import { render, staticRenderFns } from "./bindEmailOrTelDialog.vue?vue&type=template&id=6cf0cd7a&scoped=true"
import script from "./bindEmailOrTelDialog.vue?vue&type=script&lang=js"
export * from "./bindEmailOrTelDialog.vue?vue&type=script&lang=js"
import style0 from "./bindEmailOrTelDialog.vue?vue&type=style&index=0&id=6cf0cd7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf0cd7a",
  null
  
)

export default component.exports